import React, { useState } from "react";
import { signInValidator as validate } from "../../../../utility/validator/validator";
import { reduxForm } from "redux-form";

const OTPVerification = (props) => {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [error, setError] = useState("");
  const email = localStorage.getItem("opt_email");
   const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").slice(0, 6);
    
    if (/^\d+$/.test(pasteData) && pasteData.length <= 6) {
      const newOtp = [...otp];
      const pasteArray = pasteData.split("");
      
      // Fill the OTP array starting from the current input
      pasteArray.forEach((digit, index) => {
        if (index < 6) {
          newOtp[index] = digit;
        }
      });
      
      setOtp(newOtp);
      
      // Focus on the next empty input or the last input
      const nextEmptyIndex = newOtp.findIndex(digit => digit === "");
      const focusIndex = nextEmptyIndex === -1 ? 5 : Math.min(nextEmptyIndex, 5);
      
      setTimeout(() => {
        const nextInput = document.getElementById(`otp-input-${focusIndex}`);
        if (nextInput) {
          nextInput.focus();
        }
      }, 0);
      
      // Auto-submit if all fields are filled
      if (newOtp.every((digit) => digit !== "")) {
        triggerOTPSubmit(newOtp);
      }
    }
  };

  const handleChange = (e, index) => {
    const value = e.target.value;
    
    // Only allow single digits
    if (value.length > 1) {
      return;
    }
    
    const newOtp = [...otp];

    if (/^[0-9]?$/.test(value)) {
      newOtp[index] = value;
      setOtp(newOtp);

      // Auto-focus to next input if value is entered
      if (value && index < otp.length - 1) {
        setTimeout(() => {
          const nextInput = document.getElementById(`otp-input-${index + 1}`);
          if (nextInput) {
            nextInput.focus();
          }
        }, 0);
      }

      // Auto-submit if all fields are filled
      if (newOtp.every((digit) => digit !== "")) {
        triggerOTPSubmit(newOtp);
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newOtp = [...otp];

      if (otp[index] === "" && index > 0) {
        // If current field is empty, move to previous field and clear it
        newOtp[index - 1] = "";
        setOtp(newOtp);
        setTimeout(() => {
          const prevInput = document.getElementById(`otp-input-${index - 1}`);
          if (prevInput) {
            prevInput.focus();
          }
        }, 0);
      } else {
        // Clear current field
        newOtp[index] = "";
        setOtp(newOtp);
      }
      
      // Clear error when user starts typing
      if (error) {
        setError("");
      }
    }
  };

  const handleFocus = (e, index) => {
    // Select all text when input is focused
    e.target.select();
  };

  const triggerOTPSubmit = (otpArray) => {
    const otpString = otpArray.join("");
    if (isValidOTP(otpString)) {
      setError(""); // Reset error if OTP is valid
      // You can add auto-submit logic here if needed
    } else {
      setError("Please enter a valid OTP.");
    }
  };

  const isValidOTP = (otpString) => {
    return otpString.length === 6 && /^[0-9]{6}$/.test(otpString);
  };

  const onSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission
    const otpString = otp.join("");
    
    if (isValidOTP(otpString)) {
      setError("");
      
      
      if (email === null) {
        return;
      }

      const payload = {
        user: {
          email: email?.trim(),
          otp: otpString
        }
      };

      // Call the otpVerification function passed from props
      if (props.otpVerification) {
        props.otpVerification(payload);
      } else {
        console.error("otpVerification function not provided in props");
        setError("Verification function not available. Please contact support.");
      }

    } else {
      setError("Please enter a valid 6-digit OTP.");
    }
  };

  const handleResendOtp = () => {
     const email = localStorage.getItem("opt_email");
      if(email === null){
        return;
      }
      const payload = {
        user: {
          email: email?.trim()
        }
      };
      props.resendOPT(payload);
  }

  return (
    <form className="login100-form" id="login_form" onSubmit={onSubmit}>
      <div className="inner_form opt_conatiner">
        <div className="fields" style={{ marginTop: "80px" }}>
          <h1 data-test="signin_title">Verify your identity</h1>
          <h5 className="otp_modal_title">To access, enter the verification code that we emailed to you:</h5>
          <h5 class="email-style">{email ? email : "-"}</h5>
          <p className="otp_modal_title_verify">6-digit verification code</p>
          <div className="otp_input_container">
            {otp.map((digit, index) => (
              <input
                key={index}
                id={`otp-input-${index}`}
                value={digit}
                onChange={(e) => handleChange(e, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                onPaste={handlePaste}
                onFocus={(e) => handleFocus(e, index)}
                maxLength="1"
                type="text"
                inputMode="numeric"
                pattern="[0-9]"
                autoComplete="off"
                className={`otp_input ${error ? "error-border" : ""}`}
              />
            ))}
          </div>
          {error && <div className="error-message">{error}</div>}
        </div>
       <p className="otp_resend">
        Didn't get the code? 
        <span onClick={handleResendOtp} className="resend-link"> Resend it</span>
      </p>
        <button
          data-test="submit_button"
          disabled={props.isLoading}
          className={
            props.isLoading
              ? "theme_btn btn_lg btn_load btn-wait button_Disable"
              : "theme_btn btn_lg btn_load"
          }
          id="submit"
          type="submit"
        >
          {props.isLoading ? "Please wait" : "Verify"}{" "}
        </button>
      </div>
    </form>
  );
};

export default reduxForm({
  form: "signInForm",
  validate,
})(OTPVerification);
